


// import { useState, useEffect } from 'react';

export default function Hero() {
  // 2nd Quote Banner Step -01
  // const [hasScrolled, setHasScrolled] = useState(false);
  

// First Attempt:Page Load Section

  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (window.scrollY > 50) {
  //       setHasScrolled(true);
  //     } else {
  //       setHasScrolled(false); 
  //     }
  //   };

  //   window.addEventListener('scroll', handleScroll);

  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, []);

  // 2nd Quote Banner Step -02

  // useEffect(() => {
  //   const handleScroll = () => {
      
  //     if (window.scrollY > 20) {
  //       setHasScrolled(true);
  //     } else {
  //       setHasScrolled(false);
  //     }
  //   };
  
  //   window.addEventListener('scroll', handleScroll, { passive: true });
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, []);
  
  return (
    // min-h-screen
    <section id="hero"
      className="banner-section min-h-screen grid grid-cols-1 md:grid-cols-1 items-center overflow-hidden
                 relative bg-white pt-[var(--nav-h)]">

      {/* Radial glow */}
      <div className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse 60% 80% at 72% 50%, rgba(240,237,230,.7) 0%, transparent 70%)' }} />

      {/* Text */}
      <div className="banner-content relative z-10 px-[20px] md:px-[52px] py-10 md:pr-12 order-2 md:order-1 ">
      
      {/* animate-text | Animate nudge */}
        <h1 className="hero-anim animate-head animate-fade-up-1 mt-10 md:mt-5 font-serif font-light leading-[1.04]
                       tracking-[-0.01em] text-[clamp(52px,6.5vw,96px)]">
          Sometimes life just needs a <em className="italic">nudge</em>
        </h1>
        
      

        <p className="hero-anim animate-fade-up-4 delay-2 mt-4 md:mt-7 text-[16px] md:text-[24px] font-normal leading-8
                      tracking-[0.06em] text-ink ">
          Clarifying what matters. Uncovering what's possible.
          {/* Starting exactly where you are. */}
        </p>
        
        {/* <div className="hero-anim animate-fade-up-4 flex gap-4 flex-wrap mt-[25px]"> */}
          {/* <a href="#connect"
            className="btn-effect btn-bg-hover inline-flex items-center gap-2 px-8 py-3 text-[11px] font-normal
                       tracking-[0.2em] uppercase bg-ink text-white border border-ink
                        transition-colors">
            <span className='text'>Request a Session</span>
                        <span className='icon'><ArrowIcon /></span>
          </a> */}
          {/* <a href="#faq"
            className="btn-bg-hover inline-flex items-center gap-2 px-8 py-3 text-[11px] font-normal
                       tracking-[0.2em] uppercase bg-transparent text-ink border border-ink
                        hover:text-white transition-colors">
            What is life coaching?
          </a> */}
        {/* </div> */}

        {/* Scroll indicator */}
        {/* <div className="hero-anim animate-fade-up-6 hidden md:flex absolute bottom-10
                        left-[52px] flex-col items-start gap-3">
          <span className="text-[9px] tracking-[0.24em] uppercase text-muted">Scroll</span>
          <div className="w-px h-[60px] animate-scroll-pulse"
            style={{ background: 'linear-gradient(to bottom, #131210, transparent)' }} />
        </div> */}
      </div>

      {/* Image Removed as client asked | Removed that classes this parent (min-h-[600px])*/}
      <div className=" relative flex items-stretch order-2 md:order-2 px-[20px] md:px-[52px]">
        {/* <div className="flex-1 overflow-hidden">
          <img src={heroImg} alt="Life coaching session"
            className="w-full h-full object-cover object-top" />
        </div> */}

        {/* <div className="hero-anim animate-fade-up-5 hidden md:block absolute bottom-[52px]
                        -left-9 bg-white p-7 max-w-[310px] z-10
                        shadow-[0_12px_48px_rgba(19,18,16,0.1)]">
          <p className="font-serif text-base italic leading-[1.65] text-ink2">
            "Her guidance helped bring clarity and focus, which were the
            key missing ingredients for me."
          </p>
          <cite className="block mt-4 text-[10px] tracking-[0.18em] uppercase text-muted not-italic">
            Lila C. — TV Animator &amp; Designer
          </cite>
        </div> */}



{/* Without Animate Quote banner */}

         <div className="reveal delay-10 hero-anim banner-inner-content bg-black  animate-fade-up-5 delay-4 hidde text-center p-8 md:p-10 w-full z-10
                        ">
          <p className="font-serif text-[22px] md:text-[22px] italic leading-[1.65] text-white">
            "My sessions were surprising and immensely fruitful. 
            As a person who is hopeful of a second career, Alexis understood my need for a plan. 
            She empathized and encouraged my life aspirations. Her guidance helped bring clarity and focus, which were the key missing ingredients for me."
          </p>
          <cite className="block mt-4 text-[12px] md:text-[13px] tracking-[0.20em]  uppercase text-white not-italic">
            ~ Lila C. <br></br>
            TV animator and designer

          </cite>
        </div> 

{/* First Attempt: Scroll Code */}

        {/* <div 
          className={`banner-inner-content bg-black text-center p-8 md:p-10 w-full z-10 
            transition-all duration-700 ease-out
            ${hasScrolled 
              ? 'opacity-100 translate-y-0 pointer-events-auto' 
              : 'opacity-0 translate-y-10 pointer-events-none'
            }`}
        >
          <p className="font-serif text-[22px] md:text-[22px] italic leading-[1.65] text-white">
            "My sessions were surprising and immensely fruitful. 
            As a person who is hopeful of a second career, Alexis understood my need for a plan. 
            She empathized and encouraged my life aspirations. Her guidance helped bring clarity and focus, which were the key missing ingredients for me."
          </p>
          <cite className="block mt-4 text-[12px] md:text-[13px] tracking-[0.20em] uppercase text-white not-italic">
            ~ Lila C. <br />
            TV animator and designer
          </cite>
        </div> */}


{/* 2nd Quote Banner Animate */}
        
        {/* <div 
          className={`banner-inner-content bg-black text-center p-8 md:p-10 w-full z-10 
            
            transform will-change-transform backface-hidden
            transition-all duration-[800ms] ease-in-out
            ${hasScrolled 
              ? 'opacity-100 translate-y-0 pointer-events-auto' 
              : 'opacity-0 translate-y-4 pointer-events-none'
            }`}
        >
          <p className="font-serif text-[22px] md:text-[22px] italic leading-[1.65] text-white">
            "My sessions were surprising and immensely fruitful. 
            As a person who is hopeful of a second career, Alexis understood my need for a plan. 
            She empathized and encouraged my life aspirations. Her guidance helped bring clarity and focus, which were the key missing ingredients for me."
          </p>
          <cite className="block mt-4 text-[12px] md:text-[13px] tracking-[0.20em] uppercase text-white not-italic">
            ~ Lila C. <br />
            TV animator and designer
          </cite>
        </div> */}

      </div>
    </section>
  );
}
